import axios from 'axios';
import {
  USER_INFO_API_URL,
  AUTHORIZATION_LINKS_API_URL,
  SIGN_IN_API_URL,
  SIGN_OUT_API_URL
} from '../../constants/urls';

const state = {
  isAuth: false,
  id: null,
  name: null,
  link: null,
  social: null,
  authLinks: null,
  // IP приставки, если пользовтель с нее зашел на сайт
  consoleIP: ''
};

const actions = {
  async checkUserAuthData({ commit }) {
    const host = this.state.context.host;
    let url = host + USER_INFO_API_URL;

    try {
      let response = await axios({
        withCredentials: true,
        method: 'GET',
        url
      });

      if (response.status === 200) {
        commit('name', response.data.data.login);
        commit('id', response.data.data.id);
        commit('isAuth', true);
      } else {
        commit('isAuth', false);
      }
    } catch (e) {
      commit('isAuth', false);
    }
  },

  async fetchAuthInfo({ commit }) {
    const host = this.state.context.host;
    let url = host + AUTHORIZATION_LINKS_API_URL;

    try {
      let response = await axios({
        withCredentials: true,
        method: 'GET',
        url
      });

      commit('authLinks', response.data.data);
    } catch (e) {
      console.log(e);
    }
  },

  async signIn({ commit }, auth) {
    const host = this.state.context.host;
    let url = host + SIGN_IN_API_URL;

    try {
      let response = await axios({
        withCredentials: true,
        method: 'POST',
        url,
        auth
      });

        commit('name', response.data.data.login);
        commit('id', response.data.data.id);
        commit('isAuth', true);
    } catch (e) {
      commit('isAuth', false);
      throw e.response;
    }
  },

  async signOut({ commit }) {
    const host = this.state.context.host;
    let url = host + SIGN_OUT_API_URL;

    try {
      await axios({
        withCredentials: true,
        method: 'POST',
        url
      });

      commit('isAuth', false);
    } catch (e) {
      console.log(e);
    }
  },

  setConsoleIP({ commit }, consoleIP) {
    commit('setConsoleIP', consoleIP);
  },
};

const mutations = {
  isAuth(state, value) {
    state.isAuth = value;
  },

  name(state, value) {
    state.name = value;
  },

  link(state, value) {
    state.link = value;
  },

  authLinks(state, value) {
    state.authLinks = value;
  },

  id(state, value) {
    state.id = value;
  },

  social(state, value) {
    state.social = value;
  },

  setConsoleIP(state, value) {
    state.consoleIP = value;
  }
};

const getters = {
  isAuth({ isAuth }) {
    return isAuth;
  },

  userName({ name }) {
    return name;
  },

  userLink({ link }) {
    return link;
  },

  authLinks({ authLinks }) {
    return authLinks;
  },

  userId({ id }) {
    return id;
  },

  userSocial({ social }) {
    return social;
  },

  consoleIP({ consoleIP }) {
    return consoleIP;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js